import { Business } from '@type/buzzkuri/common'
import { BaseLayout } from '../Base'

type Props = {
  business: Business
  children: JSX.Element
}

export const ProgramDetailLayout = ({
  business,
  children,
}: Props): JSX.Element => {
  return (
    <BaseLayout {...{ business }}>
      <div className="mt-[78px] lg:mt-[7.2vw] w-full">
        <main>
          <div className="overflow-x-hidden w-full">{children}</div>
        </main>
      </div>
    </BaseLayout>
  )
}
